/** Public inbound mailbox (D-IH-14-N / CO-GTM-CONTACT-INBOX). Google Workspace alias on holistikaresearch.com. */
export const PUBLIC_CONTACT_EMAIL =
  process.env.NEXT_PUBLIC_CONTACT_EMAIL ?? "contact@holistikaresearch.com";
